import styled from 'styled-components';
import COLORS from 'constants/colors';

const StepIndicatorContainer = styled.div`
  display: flex;
  gap: 8px;
  width: 75%;
  margin: auto;
  margin-top: auto;
  padding-top: 16px;
`;

const StepBar = styled.div<{ isActive: boolean }>`
  flex: 1;
  height: 4px;
  border-radius: 2px;
  background-color: ${(props) =>
    props.isActive ? COLORS.BLACK : COLORS.GRAY.GRAY_400};
  transition: background-color 0.2s ease;
`;

type StepIndicatorProps = {
  totalSteps: number;
  currentStep: number;
};

const StepIndicator = ({
  totalSteps,
  currentStep,
}: StepIndicatorProps): JSX.Element => {
  return (
    <StepIndicatorContainer>
      {Array.from({ length: totalSteps }).map((_, index) => (
        <StepBar key={index} isActive={index === currentStep} />
      ))}
    </StepIndicatorContainer>
  );
};

export default StepIndicator;
